import React from "react"
import { Stack } from "@mui/material"
import { StatusChip, type StatusChipVariant } from "../atoms/StatusChip"

export type ClientChip = {
  id: string
  label: string
  tone?: StatusChipVariant
}

export type ClientContextChipsProps = {
  chips?: ClientChip[]
}

const DEFAULT_CHIPS: ClientChip[] = [
  { id: "virasafe", label: "VIRASAFE", tone: "virasafe" },
  { id: "virapath", label: "VIRAPATH", tone: "virapath" },
  { id: "dbt", label: "DBT", tone: "dbt" },
]

export function ClientContextChips({
  chips = DEFAULT_CHIPS,
}: ClientContextChipsProps) {
  return (
    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
      {chips.map((chip) => (
        <StatusChip key={chip.id} label={chip.label} tone={chip.tone} />
      ))}
    </Stack>
  )
}
